import { useEffect } from "react";
import { getUserRoleListThunk } from "tm-shared/api";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";

export const useLoadDictionaries = () => {
    const dispatch = useAppDispatch();
    const roles = useAppSelector((s) => s.dictionaries.roles);

    useEffect(() => {
        if (Object.values(roles).length > 0) return;

        dispatch(getUserRoleListThunk());
    }, [dispatch, roles]);
};
